import { InlineStack, Icon, BlockStack, InlineGrid, Modal, Badge, Button, Card, Text } from '@shopify/polaris'
import { RiskMajor } from '@shopify/polaris-icons'
import React, { useState } from 'react'
import { DIProps } from '../../../../Core'
import { appBridgeRedirect } from '../../../Panel/Panel/index'
import { FormatPriceAmount, returnDiscountedPrice } from '../../Pricing/Utilities/Helper'
import { t } from 'i18next'
interface props extends DIProps {
    orderLimitModal: boolean
    setOrderLimitModal: (val: boolean) => void
    planDetails: any
}



export const OrderLimitReachedRecommended = (props: props) => {
    const { orderLimitModal, setOrderLimitModal, planDetails } = props;
    const [activeButtonIndex, setActiveButtonIndex] = useState<number>(0);
    const [orderLimitLoader, setOrderLimitLoader] = useState<boolean>(false);


    const choosePlan = (planId: any) => {
        props.di.GET('plan/plan/choose', { plan_id: planId }).then((data: any) => {
            setOrderLimitLoader(false);
            if (data.success) {
                let tempUrl = data?.data?.confirmation_url;
                if (process.env.REACT_APP_PROD === '1') {
                    appBridgeRedirect(tempUrl, props);
                } else {
                    window.open(tempUrl);
                }
            } else {
                props.error(data?.message);
            }
        });
    };




    if (Object.keys(planDetails?.recommendedPlan)?.includes('monthly')) {
        return (
            <Modal open={orderLimitModal} onClose={() => setOrderLimitModal(false)} title={<InlineStack wrap={false} blockAlign='start' gap={"200"}>
                <span><Icon source={RiskMajor} tone='critical' /></span>
                <Text as='p' variant='headingMd'>{t("Order Limit Reached – Here’s What You Can Do!")}</Text>
            </InlineStack>}>
                <Modal.Section>
                    <BlockStack gap={"500"}>
                        <Text as='p' variant='bodyMd' tone='subdued'>{t("Your plan’s order limit is exhausted! From here on, the capping limit for your additional orders will begin. We recommend upgrading to plans that keep up with your growing business.")}</Text>
                        <div className='custom-order-limit-reached__recommended'>
                            <InlineStack>
                                <div className='custom-order-limit-reached__current'>
                                    <BlockStack gap={"600"}>
                                        <BlockStack gap={"100"} inlineAlign='start'>
                                            <Badge size='medium'>{t("Current Plan")}</Badge>
                                            <Text as='p' variant='headingMd'>{planDetails?.planName + ' Plan' || ''}</Text>
                                        </BlockStack>
                                        <InlineStack gap={"050"}>
                                            <Text as='p' variant='bodyLg' fontWeight='medium' tone='subdued'>{t("Limit used:")}</Text>
                                            <Text as='p' variant='bodyLg' tone='critical'>{planDetails?.usedCredits}</Text>
                                            <Text as='p' variant='bodyLg' tone='subdued'>/{planDetails?.totalCredits}</Text>
                                        </InlineStack>
                                    </BlockStack>
                                </div>
                                <div className='custom-order-limit-reached__recomm-card'>
                                    <BlockStack gap={"600"}>
                                        <BlockStack gap={"100"} inlineAlign='start'>
                                            <Badge size='medium' tone='warning'>{t("Recommended")}</Badge>
                                            <InlineStack gap={"150"} blockAlign='center'>
                                                <Text as='p' variant='headingMd'>{planDetails?.recommendedPlan?.monthly?.title + ' Plan'}</Text>
                                                <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="3" cy="3" r="3" fill="#E3E3E3" />
                                                </svg>
                                                <Text as='p' variant='bodySm' tone='subdued'><>{t("Manage")}{' '}</>
                                                    {
                                                        planDetails?.recommendedPlan?.monthly?.services_groups?.[0]?.services?.[0]?.prepaid?.service_credits

                                                    }
                                                    <> {' '}{t("orders per month")} </></Text>
                                            </InlineStack>
                                        </BlockStack>
                                        <InlineStack gap={"300"} align='space-between' blockAlign='end'>
                                            {Object.values(planDetails?.recommendedPlan?.monthly?.discounts)?.length > 0
                                                ?
                                                <InlineStack gap="200" wrap={false}>
                                                    <Text as='span' variant='headingXl' fontWeight='medium'>
                                                        <del>
                                                            $ {Math.ceil(planDetails?.recommendedPlan?.monthly?.custom_price || 0)} {' '} /mo
                                                        </del>
                                                        <Text as='span' variant='bodySm' fontWeight='medium'>/mon</Text>
                                                    </Text>

                                                    <InlineStack gap="100">
                                                        <Text as='span' variant='headingXl' fontWeight='medium'>$</Text>
                                                        <Text
                                                            as='span' variant='headingXl' fontWeight='medium'
                                                        >
                                                            {
                                                                FormatPriceAmount((+returnDiscountedPrice(planDetails?.recommendedPlan?.monthly?.discounts, planDetails?.recommendedPlan?.monthly?.custom_price) / 12).toFixed(2))
                                                            }
                                                        </Text>
                                                    </InlineStack>
                                                </InlineStack>
                                                :
                                                <InlineStack gap="050" wrap={false}>
                                                    <Text as='span' variant='headingXl' fontWeight='medium' > $ </Text>
                                                    <Text as='span' variant='headingXl' fontWeight='medium'>{planDetails?.recommendedPlan?.monthly?.custom_price ?? 0} </Text>
                                                    <Text as='span' variant='headingXl' fontWeight='medium'>/mo</Text>
                                                </InlineStack>
                                            }
                                            <Button variant='primary' loading={orderLimitLoader} onClick={() => {

                                                setOrderLimitLoader(true);
                                                console.log(planDetails)
                                                planDetails?.recommendedPlan?.monthly?.in_app_recommended ? chooseRecomendedPlan(props, () => setOrderLimitModal(false)) :
                                                    choosePlan(planDetails?.recommendedPlan?.monthly?.plan_id);

                                            }} size='medium'>{t("Upgrade Now")}</Button>
                                        </InlineStack>
                                    </BlockStack>
                                </div>
                            </InlineStack>
                        </div>
                    </BlockStack>
                </Modal.Section>
            </Modal>
        )
    } else {
        return (
            <Modal open={orderLimitModal} size='small' onClose={() => setOrderLimitModal(false)} title={<InlineStack wrap={false} blockAlign='start' gap={"200"}>
                <span><Icon source={RiskMajor} tone='critical' /></span>
                <Text as='p' variant='headingMd'>{t("You have reached your Order Limit!")}</Text>
            </InlineStack>}>
                <Modal.Section>
                    <BlockStack gap={"500"}>
                        <Text as='p' variant='bodyMd' tone='subdued'>{t("The additional order limit is now active. Please note you will be charged for extra orders within the capped amount, after which order sync will be paused.")}</Text>
                        <Card padding={"500"}>
                            <InlineGrid gap={"400"} columns={2}>
                                <BlockStack gap={"100"} inlineAlign='start'>
                                    <Badge size='medium'>{t("Current Plan")}</Badge>
                                    <Text as='p' variant='headingMd'>{planDetails?.planName + ' Plan' || ''}</Text>
                                </BlockStack>
                                <BlockStack gap={"100"}>
                                    <Text as='p' variant='bodyLg' fontWeight='medium' tone='subdued'>{t("Limit used:")}</Text>
                                    <Text as='span' variant='bodyLg' tone='critical'>{planDetails?.usedCredits}
                                        <Text as='span' variant='bodyLg' tone='subdued'>/{planDetails?.totalCredits}</Text>
                                    </Text>
                                </BlockStack>
                            </InlineGrid>
                        </Card>
                        <Button size='medium' variant='primary' onClick={() => {
                            setOrderLimitModal(false);
                            props.history('home/pricing',
                                {
                                    replace: false,
                                    state: {
                                        billed_type: Object?.keys(planDetails?.recommendedPlan)?.includes('monthly') ? 'monthly' : 'yearly'
                                    }
                                }
                            );
                        }}>{t("View All Plans")}</Button>
                    </BlockStack>
                </Modal.Section>
            </Modal>
        )
    }

}

export const chooseRecomendedPlan = (props: any, callback?: any) => {
    props.di.GET('plan/plan/activateCustomRecommendedPlan').then((data: any) => {
        if (callback) {
            callback(false)
        }
        if (data.success) {
            let tempUrl = data?.payment_link?.monthly;
            if (process.env.REACT_APP_PROD === '1') {
                appBridgeRedirect(tempUrl, props);
            } else {
                window.open(tempUrl);
            }
        } else {
            props.error(data?.message);
        }
    });
};

